import React, {Component} from 'react'
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom'
import talkIcon from '../../img/Talk.png'
import quizIcon from '../../img/Quiz.png'
import libraryIcon from '../../img/Library.png'
import helpIcon from '../../img/Help.png'
import Talk from "../Talk/index";
import Quiz from "../Quiz";
import Library from "../Library";
import Refer from "../Help";
import EmojiIcon from '../EmojiIcon'

class Youth extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentWillMount() {
    document.body.style.backgroundColor = '#71d5e4';
  }
  componentWillUnmount() {
    document.body.style.backgroundColor = null;
  }

  render() {
    let router =
        <div>
          <Switch>
            <Route path='/youth/talk' component={Talk} />
            <Route path='/youth/quiz' component={Quiz} />
            <Route path='/youth/library' component={Library} />
            <Route path='/help' component={Refer} />
            <Route exact path="/youth" render={() => {
              return(
                  <div className="homeYouth">
                    <div className=" btn-group-vertical">
                      <Link className="btn btn-lg home-button" to="/youth/talk">
                        <img className="section-img" src={talkIcon}/>     
                      </Link>
                      <Link className="btn btn-lg home-button" to="/youth/quiz">
                        <img className="section-img" src={quizIcon}/>
                      </Link>
                      <Link className="btn btn-lg home-button" to="/youth/library">
                        <img className="section-img" src={libraryIcon}/>
                      </Link>
                      <Link className="btn btn-lg home-button" to="/help">
                        <img className="section-img" src={helpIcon}/>
                      </Link>
                    </div>
                  </div>
              )
            }} />
          </Switch>
        </div>;
    return (
        <Router>
          <div>
            {router}
          </div>
        </Router>
    );
  }
}

export default Youth;



// WEBPACK FOOTER //
// ./src/components/Youth/index.js